import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    icon: '🧭',
    title: 'Un percorso chiaro, giorno per giorno',
    desc: '21 giorni di pratiche in sequenza. Senza improvvisare, senza chiederti cosa fare oggi. Basta seguire il sistema.'
  }, {
    icon: '🛡️',
    title: 'Strumenti per il momento dell\'impulso',
    desc: 'Non sei più senza difese quando il ciclo tira più forte. Hai una risposta pronta.'
  }, {
    icon: '🔓',
    title: 'La colpa smette di essere il ponte di ritorno',
    desc: 'Lavori con la colpa invece di sopprimerla. Questo rompe il legame che la trasforma in innesco.'
  }, {
    icon: '⏱️',
    title: 'Pratiche da 5 a 15 minuti',
    desc: 'Senza stravolgere la tua vita. Senza scuse sul tempo. Se hai tempo per il ciclo, hai tempo per interromperlo.'
  }, {
    icon: '🤝',
    title: 'Un linguaggio senza giudizio né etichette',
    desc: 'Accompagni te stesso/a invece di attaccarti. Il processo è gentile con chi lo fa.'
  }, {
    icon: '🔒',
    title: '100% privato',
    desc: 'Nessuno deve sapere che stai lavorando su questo. È tra te e il processo.'
  }];
  return <section className="py-6 md:py-9 px-5 bg-gradient-to-b from-card-bg to-dark-bg" data-id="element-14" data-mp="2l58p2tj3v41o">
      <div className="max-w-[900px] mx-auto" data-id="element-15" data-mp="2g5dykr38sgh5">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-16" data-mp="2g6nyzmxki0qy">
          Cosa ottieni
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-17" data-mp="1ofhrglfip0rn">
          Non più informazioni.
          <br data-id="element-18" data-mp="22fsm7zjy6zi3" />
          <span className="text-gradient-magenta" data-id="element-19" data-mp="22c4rix2ro71s">Strumenti reali.</span>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-4" data-id="element-20" data-mp="1xe3a0gkzofsf">
          {benefits.map((benefit, idx) => <div key={idx} className="flex flex-col bg-gradient-to-br from-[rgba(107,0,182,0.12)] to-[rgba(194,0,111,0.08)] border border-[rgba(107,0,182,0.3)] rounded-2xl p-4 transition-[transform,border-color,box-shadow] duration-200 ease-out hover:-translate-y-[5px] hover:border-magenta hover:shadow-[0_10px_40px_rgba(194,0,111,0.2)]" data-id="element-21" data-mp="38ujq8c4db0gc" data-mpi={idx}>
              <div className="text-[2rem] mb-2" data-id="element-22" data-mp="3pu4hs13gv8h4">{benefit.icon}</div>
              <h4 className="text-[1.05rem] font-heading font-extrabold text-white mb-1" data-id="element-23" data-mp="3uuifoqbct21f">
                {benefit.title}
              </h4>
              <p className="text-[0.9rem] leading-[1.5] text-white/70" data-id="element-24" data-mp="326cuy3kavd1l">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}